import { useEffect } from 'react';

const useScript = (url, handleOnScriptLoad = () => {}, async = false) => {
  useEffect(() => {
    const script = document.createElement('script');

    script.src = url;
    script.async = async;

    document.head.appendChild(script);

    script.onload = function () {
      handleOnScriptLoad();
    };

    return () => {
      document.head.removeChild(script);
    }
  }, [url]);
};

export default useScript;
